export default [
    {
        path: '/sms-sablonu',
        name: 'sms-sablonu',
        meta: { resource: 'admin' },
        component: () => import('../views/sms/schema')
    },
    {
        path: '/sabit-giden-smsler',
        name: 'sabit-giden-smsler',
        meta: { resource: 'admin' },
        component: () => import('../views/sms/static')
    }
]
  